export class CustomerLimit {
  public static limit = 50;
  public static offset = 0;
  public static pageNumber = 1;
  public static totalItemsCount = 1;
  public static searchLeadsCount = 5;
}
